import { createWorkflowResponse } from './create'

export const workflowResponses = {
  create: createWorkflowResponse,
}
